import React, { useRef, useEffect, useState, use } from 'react';
import Icon from 'components/Icon';
import { useSelector, useDispatch } from 'react-redux';
import * as ACTIONS_APP from 'actions/App';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { fetchUserNotifications, fetchUserNotificationsCompany } from 'actions/Notifications';
import NotificationsDisplayList from 'components/NotificationsDisplayList';
import { useIntl } from 'react-intl';
import { removeUserNotifications, removeUserNotificationsAll } from '../actions/Notifications';


const NotificationModal = ({ isVisible, onClose, position, placement, children }) => {
    const modalRef = useRef(null);
    const { x, y, arrowOffset } = position;
    const myFacility = useSelector((state) => state.reports.myFacility);
    const location = useLocation();
    const isAllFacilityView = location.pathname === '/app/facilities/allFacilities';
    const isMyFacilityView = location.pathname === '/app/facilities/myFacilities';
    const userNotifications = useSelector((state) => state.notifications.userNotifications);
    const dispatch = useDispatch();
    const authUser = useSelector((state) => state.auth.authUser);

    const notificationsCompany = useSelector((state) => state.notifications.userNotificationsCompany);
    const [notifications, setNotifications] = useState([]);
    const [selectedTab, setSelectedTab] = useState('all');
    const notificationsCount = useSelector((state) => state.app.notificationsCount);
    const [dismissAllNotificationsState, setDismissAllNotificationsState] = useState(false);
    const [dismissFacilityNotificationsState, setDismissFacilityNotificationsState] = useState(false);
    const intl = useIntl();
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                setSelectedTab('all');
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    useEffect(() => {
        setNotifications(notificationsCompany);
        // dispatch(ACTIONS_APP.setNotificationsCount(notifications.length));
    }, [notificationsCompany]);

    const showDismissAllIcon = () => {
        if (selectedTab === 'all' && notificationsCount > 0) {
            return true;
        }

        if (
            selectedTab === 'facility' &&
            notificationsCount > 0 &&
            myFacility &&
            myFacility.id
        ) {
            return notifications.some(
                (notification) => notification && String(notification.siteID).trim() === String(myFacility.id).trim()
            );
        }
        return false;
    };
    const dismissAllNotifications = () => {
        if (selectedTab === 'all') {
            dispatch(removeUserNotificationsAll());
            setNotifications([]);
            dispatch(ACTIONS_APP.setNotificationsCount(0));
            setDismissAllNotificationsState(!dismissAllNotificationsState);
        } else {
            let dismissIds = [];
            notificationsCompany.forEach((notification) => {
                if (String(notification.siteID).trim() === String(myFacility.id).trim()) {
                    dismissIds.push(String(notification.id));
                }
            });
            let unDismissedNotifications = notificationsCompany.filter(
                (notification) => !dismissIds.includes(String(notification.id))
            );
            setNotifications(unDismissedNotifications);
            dispatch(removeUserNotifications(dismissIds));
            dispatch(ACTIONS_APP.setNotificationsCount(unDismissedNotifications.length));
            setDismissFacilityNotificationsState(!dismissFacilityNotificationsState);
        }
    };
  
    if (!isVisible) return null;

    const arrowBase = 'absolute w-0 h-0';
    const arrowStyles = {
        bottom: 'border-l-8 border-r-8 border-b-8 border-transparent border-b-white',
        right: 'border-t-8 border-b-8 border-r-8 border-transparent border-r-white',
        left: 'border-t-8 border-b-8 border-l-8 border-transparent border-l-white'
    };

    const arrowPosition = {
        bottom: { top: '-10px', left: `${arrowOffset - 2}px` },
        right: { top: `${arrowOffset + 1}px`, left: '-8px' },
        left: { top: `${arrowOffset}px`, right: '-8px' }
    };

    // Move modal a little to the left by subtracting, e.g., 20px from x
    const adjustedX = x;
    // Determine modal height based on y position
    const modalHeight = y === 0 ? '400px' : '568px';

    return (
        <div className="fixed inset-0 bg-black/30 z-20 flex items-start p-2 pr-4">
            <div
                ref={modalRef}
                className="relative bg-white rounded-xl p-4 shadow-xl background-color: var(--color-white); w-[680px] flex flex-col"
                style={{
                    top: y,
                    left: adjustedX,
                    height: modalHeight,
                    // Ensures 10px padding regardless of zoom
                    boxSizing: 'border-box'
                }}>
                <div className={`${arrowBase} ${arrowStyles[placement]}`} style={arrowPosition[placement]} />
                <div
                    onClick={onClose}
                    className="flex flex-row p-4 bg-white items-center gap-2 self-stretch justify-between">
                    <h5 className="text-[#3E3E3E] font-outfit text-[24px] font-bold leading-[28px] tracking-[-0.48px]">
                        Notifications
                    </h5>
                    <Icon name="close" className="cursor-pointer" />
                </div>

                <div className="flex flex-row border-b border-[#E0E0E0] mb-4  items-center">
                    {!isAllFacilityView && !isMyFacilityView && myFacility && (
                        <div className="px-4">
                            <div
                                className={` py-2 cursor-pointer border-b-2 ${selectedTab === 'facility' ? 'border-[#0094CC]' : 'border-transparent'} hover:border-[#0094CC] focus:border-[#0094CC]`}
                                data-selected={selectedTab === 'facility'}
                                onClick={() => setSelectedTab('facility')}
                                style={{ display: 'inline-block', width: 'fit-content' }}>
                                <p className="text-black text-[18px] font-semibold leading-[18px] tracking-[0.18px] font-[Outfit]">
                                    {myFacility.name}
                                </p>
                            </div>
                        </div>
                    )}
                    <div className="px-4">
                        <div
                            className={` py-2 cursor-pointer border-b-2 ${selectedTab === 'all' ? 'border-[#0094CC]' : 'border-transparent'} hover:border-[#0094CC] focus:border-[#0094CC]`}
                            data-selected={selectedTab === 'all'}
                            onClick={() => setSelectedTab('all')}
                            style={{ display: 'inline-block', width: 'fit-content' }}>
                            <p className="text-black text-[18px] font-semibold leading-[18px] tracking-[0.18px] font-[Outfit]">
                                {intl.formatMessage({ id: 'notifications.allfacilities' })}
                            </p>
                        </div>
                    </div>
                    <div className="ml-auto pb-3">
                        {/* Add your element here */}
                        {showDismissAllIcon() && (
                            <button
                                type="button"
                                onClick={() => dismissAllNotifications()}
                                className="h-10 px-5  bg-white rounded-full cursor-pointer outline outline-1 outline-offset-[-1px] outline-gray-100 flex items-center gap-2">
                                <span className="text-gray-800 text-base font-semibold leading-none">
                                    {intl.formatMessage({ id: 'pages.users.dismissAll' })}
                                </span>
                            </button>
                        )}
                    </div>
                </div>
                {/* Notifications List */}
                <NotificationsDisplayList
                    notifications={notifications}
                    selectedTab={selectedTab}
                    myFacility={myFacility}
                    dismissAllNotificationsState={dismissAllNotificationsState}
                    dismissFacilityNotificationsState={dismissFacilityNotificationsState}
                />
            </div>
        </div>
    );
};
export default NotificationModal;
